export default __webpack_public_path__ + "static/media/blog8.9faabe4e.jpg";